import { FC, Fragment } from 'react';
import DataRow, { DataRowItem } from '@/libs/antd/components/DataRow';
import FleetTitle from '@/libs/antd/components/Title';
import {
	CustomerBusinessDocument,
	CustomerLegalDocument,
	CustomerReferralDocument,
	MainInformation as MainInformationType,
	// ExistingFinancingLimitInformation,
	// FinancingApplicationLimitInformation,
} from '@/libs/fleet-api/services/types';
import { useModals } from '@/components/modals/ModalProvider';
import { DocumentItem } from '@/components/modals/DocumentModal';
import dayjs from 'dayjs';
import { ProspectSteps } from '@/libs/fleet-api/services/pipeline';
// import { formatCurrency } from '@/libs/antd/formater';

type PipelineMainInformationProps = {
	mainInformation?: MainInformationType & {
		appliedPlafond: number;
		existingPlafond: number;
		applicationStatus: string;
		newOrderDate: string;
		outstandingPrincipal: number;
		napNo?: string;
	};
	customerLegalDocuments?: CustomerLegalDocument[];
	customerBusinessDocuments?: CustomerBusinessDocument[];
	customerReferralDocuments?: CustomerReferralDocument[];
	// prospectInformation: {
	// 	existingFinancingLimitInformation: ExistingFinancingLimitInformation[];
	// 	financingApplicationLimitInformation: FinancingApplicationLimitInformation[];
	// };
	isLoading?: boolean;
	prospectStatusId: ProspectSteps;
};

const PipelineMainInformation: FC<PipelineMainInformationProps> = ({
	mainInformation = null,
	customerLegalDocuments = [],
	customerBusinessDocuments = [],
	customerReferralDocuments = [],
	isLoading = false,
	prospectStatusId,
}) => {
	const {
		openCustomerDetail,
		openProspectDetail,
		openCustomerGroupDetail,
		openDocumentModal,
		// openMapModal,
		openCustomerCheckingModal,
		openPraSurveyAnalysisModal,
		openPraSurveyDataModal,
	} = useModals();

	const customerInfoDataRow: DataRowItem[] = [
		[
			[
				'Nama Customer',
				<a
					key="customer-name"
					href="#"
					className="trigger-popup"
					onClick={(e) => {
						e.preventDefault();
						openCustomerDetail(mainInformation!.customerId);
					}}
				>
					{mainInformation?.customerName}
				</a>,
			],
			[
				'Prospect ID',
				<a
					key="prospect-id"
					href="#"
					className="trigger-popup"
					onClick={(e) => {
						e.preventDefault();
						openProspectDetail(mainInformation!.prospectId);
					}}
				>
					{mainInformation?.prospectId}
				</a>,
			],
		],
		[
			['Kelas Industri', mainInformation?.industrySector?.industryClass],
			['Sumber Order', mainInformation?.orderSource],
		],
		[
			[
				'Portofolio Guideline',
				mainInformation?.industrySector?.portofolioGuideline,
			],
			[
				'Group Customer BMPP',
				mainInformation!.customerGroup.id ? (
					<a
						key="group-customer"
						href="#"
						className="trigger-popup"
						onClick={(e) => {
							e.preventDefault();
							openCustomerGroupDetail(mainInformation!.customerGroup.id);
						}}
						aria-disabled={!mainInformation?.customerGroup.value}
					>
						{mainInformation?.customerGroup.value ?? '-'}
					</a>
				) : (
					'-'
				),
			],
		],
		[
			[
				'Dokumen',
				<a
					key="document-preview"
					href="#"
					className="trigger-popup"
					onClick={(e) => {
						e.preventDefault();

						const documents: DocumentItem[] = [];
						const getDocumentType = (name: string) => {
							if (name.endsWith('pdf')) return 'pdf';
							if (name.endsWith('jpeg')) return 'jpeg';
							if (name.endsWith('jpg')) return 'jpg';
							if (name.endsWith('png')) return 'png';
						};

						if (customerLegalDocuments?.length) {
							customerLegalDocuments
								.filter((doc) => doc.file)
								.forEach((document) => {
									documents.push({
										name: document.documentType,
										type: getDocumentType(document.file.name)!,
										url: document.file.url,
									});
								});
						}

						if (customerBusinessDocuments?.length) {
							customerBusinessDocuments
								.filter((doc) => doc.file)
								.forEach((document) => {
									documents.push({
										name: document.documentType,
										type: getDocumentType(document.file.name)!,
										url: document.file.url,
									});
								});
						}
						if (customerReferralDocuments?.length) {
							customerReferralDocuments
								.filter((doc) => doc.file)
								.forEach((document) => {
									documents.push({
										name: document.documentType,
										type: getDocumentType(document.file.name)!,
										url: document.file.url,
									});
								});
						}

						if (documents.length) {
							openDocumentModal(documents);
						} else {
							alert('no document found');
						}
					}}
				>
					View Dokumen
				</a>,
			],
			[
				'Customer Checking',
				<a
					key="customer-checking"
					className="trigger-popup"
					onClick={(e) => {
						e.preventDefault();
						if (prospectStatusId < ProspectSteps.Capv) return;
						openCustomerCheckingModal(mainInformation?.prospectId ?? '');
					}}
					style={
						prospectStatusId < ProspectSteps.Capv
							? { color: 'grey', cursor: 'default' }
							: {}
					}
				>
					Detail Analisa
				</a>,
			],
		],
		[
			[
				'Data Pra-Survey',
				<a
					key="data-pra-survey"
					onClick={(e) => {
						e.preventDefault();
						if (prospectStatusId < ProspectSteps.SbApp) return;
						openPraSurveyDataModal(mainInformation?.prospectId ?? '');
					}}
					className="trigger-popup"
					style={
						prospectStatusId < ProspectSteps.SbApp
							? { color: 'grey', cursor: 'default' }
							: {}
					}
				>
					Detail Pra-Survey
				</a>,
			],
			[
				'Analisa Pra-Survey',
				<a
					key="analisa-pra-survey"
					onClick={(e) => {
						e.preventDefault();
						if (prospectStatusId < ProspectSteps.ScApp) return;
						openPraSurveyAnalysisModal(mainInformation?.prospectId ?? '');
					}}
					className="trigger-popup"
					style={
						prospectStatusId < ProspectSteps.ScApp
							? { color: 'grey', cursor: 'default' }
							: {}
					}
				>
					Detail Analisa
				</a>,
			],
		],
		// [
		// 	[
		// 		'Outstanding Principal',
		// 		mainInformation?.outstandingPrincipal
		// 			? formatCurrency(mainInformation?.outstandingPrincipal)
		// 			: '-',
		// 	],
		// 	[
		// 		'Plafond Existing',
		// 		mainInformation?.existingPlafond
		// 			? formatCurrency(mainInformation?.existingPlafond)
		// 			: '-',
		// 	],
		// ],
		// [
		// 	['Plafond Diajukan', formatCurrency(mainInformation?.appliedPlafond)],
		// 	['Detail Sumber Order', mainInformation?.orderSource],
		// ],
		[
			['Status Pengajuan', mainInformation?.applicationStatus],
			[
				'New Order Date',
				dayjs(mainInformation?.newOrderDate).format('DD-MM-YYYY'),
			],
		],
	];
	if (mainInformation?.napNo) {
		customerInfoDataRow.unshift([
			[
				'No. NAP',
				<strong style={{ color: '#1557BC' }}>{mainInformation?.napNo}</strong>,
			],
		]);
	}

	return (
		<Fragment>
			<FleetTitle>Main Information</FleetTitle>
			<DataRow
				items={customerInfoDataRow}
				loading={isLoading}
				style={{
					marginBottom: 20,
				}}
			/>
		</Fragment>
	);
};

export default PipelineMainInformation;
